export const Footer = () => {
  return (
    <div className="footer">
      <span>©Sagar Shiroya</span>
    </div>
  );
};
